import React, { useEffect, useState, useRef } from "react";
import { FalkeCoinLogo } from "./Brand";

/**
 * CoinEarnAnimation: Wenn eine ungelesene "coin_gutschrift"-Notification kommt,
 * fliegt eine Münze von oben nach unten + "+200 FC" Label.
 * Nur die NEUESTE Notification triggert die Animation.
 */
export default function CoinEarnAnimation({ notifications }) {
  const [activeBurst, setActiveBurst] = useState(null);
  const seenRef = useRef(new Set());

  useEffect(() => {
    if (!notifications || notifications.length === 0) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    // Beim ersten Mount alle bekannten als "gesehen" markieren (verhindert Burst beim Login)
    if (seenRef.current.size === 0) {
      notifications.forEach((n) => seenRef.current.add(n.id));
      return;
    }
    const newest = notifications.find((n) => n.kind === "coin_gutschrift" && !seenRef.current.has(n.id));
    if (newest) {
      seenRef.current.add(newest.id);
      const match = /\+(\d+)/.exec(newest.body || newest.title || "");
      const amount = match ? parseInt(match[1], 10) : null;
      setActiveBurst({ id: newest.id, amount, body: newest.body });
      setTimeout(() => setActiveBurst(null), 1500);
    }
  }, [notifications]);

  if (!activeBurst) return null;

  return (
    <div className="fixed inset-0 pointer-events-none z-[55] flex items-start justify-center" data-testid="coin-earn-animation">
      <div className="relative w-full max-w-md mx-auto mt-20">
        <div className="coin-fly-down absolute left-1/2" style={{ top: 0 }}>
          <FalkeCoinLogo size={72} glow />
        </div>
        {activeBurst.amount && (
          <div className="float-up absolute left-1/2 -translate-x-1/2 mt-32">
            <div className="px-5 py-2 rounded-full bg-falke-orange text-white font-heading font-bold text-2xl shadow-xl tabular">
              +{activeBurst.amount} FC
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
